import { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const languages = [
  { code: 'pt', flag: '🇧🇷', label: 'Português' },
  { code: 'en', flag: '🇺🇸', label: 'English' },
  { code: 'es', flag: '🇪🇸', label: 'Español' },
  { code: 'fr', flag: '🇫🇷', label: 'Français' },
  { code: 'de', flag: '🇩🇪', label: 'Deutsch' },
  { code: 'zh', flag: '🇨🇳', label: '中文' },
];

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  const current = languages.find((l) => l.code === i18n.language) || languages[0];

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const switchLang = (code: string) => {
    i18n.changeLanguage(code);
    setOpen(false);
  };

  return (
    <div ref={ref} className="relative">
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-1.5 text-sm px-3 py-2 rounded-lg bg-background-50 border border-background-200 hover:border-background-300 transition-colors cursor-pointer whitespace-nowrap"
        aria-label="Switch language"
      >
        <span className="text-base leading-none">{current.flag}</span>
        <span className="text-xs font-medium text-foreground-700">{current.label}</span>
        <div className="w-3 h-3 flex items-center justify-center">
          <i className={`text-xs text-foreground-400 transition-transform ${open ? 'rotate-180' : ''} ri-arrow-down-s-line`}></i>
        </div>
      </button>

      {open && (
        <div className="absolute right-0 top-full mt-1 bg-background-50 border border-background-200 rounded-xl shadow-lg py-1 z-50 min-w-[160px]">
          {languages.map((lang) => (
            <button
              key={lang.code}
              onClick={() => switchLang(lang.code)}
              className={`w-full flex items-center gap-2.5 px-4 py-2.5 text-sm transition-colors cursor-pointer whitespace-nowrap hover:bg-background-100 ${lang.code === current.code ? 'bg-primary-50 font-semibold text-primary-600' : 'text-foreground-600'}`}
            >
              <span className="text-base leading-none">{lang.flag}</span>
              <span>{lang.label}</span>
              {lang.code === current.code && (
                <div className="w-3 h-3 flex items-center justify-center ml-auto">
                  <i className="ri-check-line text-primary-500 text-xs"></i>
                </div>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;